var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "80%",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-table",
                {
                  ref: "tableList",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableList, height: "calc(100%)" },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "50", type: "index" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件编号",
                      align: "center",
                      prop: "Code",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件名称",
                      align: "center",
                      prop: "Name",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件类型",
                      align: "center",
                      prop: "MaterialTypeName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备件规格",
                      align: "center",
                      prop: "Spec",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "单位",
                      align: "center",
                      prop: "storageName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "货位",
                      align: "center",
                      prop: "LocalName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "库存数量",
                      align: "right",
                      prop: "Nums_N",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "工单数量",
                      align: "right",
                      prop: "Num",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "剩余领料数量",
                      align: "right",
                      prop: "RemainingQuantity",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "本次领料数量",
                      align: "center",
                      prop: "Quantity",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { type: "number", controls: false },
                              on: {
                                input: function ($event) {
                                  return _vm.NumChange($event, scope.row)
                                },
                              },
                              model: {
                                value: scope.row.Quantity,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "Quantity", $$v)
                                },
                                expression: "scope.row.Quantity",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }